import React, { Suspense, useEffect } from "react";
import ReactDOM from "react-dom";
import "./assets/css/tailwind.output.css";
import App from "./App";
import { SidebarProvider } from "./context/SidebarContext";
import ThemedSuspense from "./components/ThemedSuspense";
import { Windmill } from "@windmill/react-ui";
import * as serviceWorker from "./serviceWorker";
import { AdminProvider } from "./context/AdminContext";
import "react-toastify/dist/ReactToastify.css";
import ToastProvider from "./context/ToastProvider";
import { GlobalStateProvider } from "./context/GlobalStateContext";

// Add security headers
const addSecurityHeaders = () => {
  // Create meta tags for security headers
  const metaTags = [
    { httpEquiv: 'Cross-Origin-Opener-Policy', content: 'same-origin-allow-popups' },
    { httpEquiv: 'Cross-Origin-Embedder-Policy', content: 'require-corp' }
  ];

  // Remove any existing meta tags with these names
  metaTags.forEach(tag => {
    const existingTag = document.querySelector(`meta[http-equiv="${tag.httpEquiv}"]`);
    if (existingTag) {
      existingTag.remove();
    }
  });

  // Add new meta tags
  metaTags.forEach(tag => {
    const meta = document.createElement('meta');
    meta.httpEquiv = tag.httpEquiv;
    meta.content = tag.content;
    document.head.appendChild(meta);
  });
};

// Initialize Google API
// const initGoogleAPI = () => {
//   return new Promise((resolve, reject) => {
//     if (window.gapi && window.google) {
//       console.log("Google APIs already loaded");
//       resolve();
//       return;
//     }

//     const checkInterval = setInterval(() => {
//       if (window.gapi && window.google) {
//         clearInterval(checkInterval);
//         console.log("Google APIs loaded successfully");
//         resolve();
//       }
//     }, 100);

//     setTimeout(() => {
//       clearInterval(checkInterval);
//       reject(new Error("Google APIs failed to load within timeout"));
//     }, 10000);
//   });
// };

// Root component with initialization
const Root = () => {
  useEffect(() => {
    // Add security headers
    addSecurityHeaders();

    // Initialize Google API
    // initGoogleAPI()
    //   .then(() => {
    //     if (window.gapi) {
    //       window.gapi.load("client", () => {
    //         window.gapi.client.init({
    //           apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    //           discoveryDocs: ["https://www.googleapis.com/discovery/v1/apis/drive/v3/rest"],
    //         }).then(() => {
    //           console.log("Google API client initialized successfully");
    //         }).catch((error) => {
    //           console.error("Error initializing Google API client:", error);
    //         });
    //       });
    //     }
    //   })
    //   .catch((error) => {
    //     console.error("Error loading Google APIs:", error);
    //   });
  }, []);

  return (
    <React.StrictMode>
      <AdminProvider>
        <ToastProvider>
          <GlobalStateProvider>
            <SidebarProvider>
              <Suspense fallback={<ThemedSuspense />}>
                <Windmill usePreferences>
                  <App />
                </Windmill>
              </Suspense>
            </SidebarProvider>
          </GlobalStateProvider>
        </ToastProvider>
      </AdminProvider>
    </React.StrictMode>
  );
};

ReactDOM.render(<Root />, document.getElementById("root"));

serviceWorker.register();
